/**
 * Инлайн-SVG иконки для кнопок-иконок (.icon-btn).
 * Иконки задаются разметкой, а не отдельными файлами: деплой фронтенда заливает
 * dist/frontend/* не рекурсивно, поэтому папка assets/ в бакет не попадёт, а
 * иконочные шрифты и внешние CDN запрещены (docs/tasks/05-styles-and-layout.md).
 * Цвет, толщину линии и размер задаёт CSS (.icon-btn svg, .masthead__chevron svg):
 * здесь только геометрия.
 */

/** Пространство имён SVG: элементы SVG создаются через createElementNS, не innerHTML. */
const SVG_NS = 'http://www.w3.org/2000/svg';

/** Размер холста иконки (совпадает с размером .icon-btn svg в CSS). */
const ICON_SIZE = 24;
const ICON_STROKE_WIDTH = 2;

/** Какие иконки доступны: имя — смысл действия. */
export type IconName = 'edit' | 'check' | 'close' | 'trash' | 'plus' | 'chevron-down';

/** Контуры (paths) каждой иконки в системе координат 24×24, рисуются только обводкой. */
const ICON_PATHS: Record<IconName, string[]> = {
  edit: ['M4 20h4l10-10-4-4L4 16v4z', 'M14 6l4 4'],
  check: ['M5 13l4 4L19 7'],
  close: ['M6 6l12 12', 'M18 6L6 18'],
  trash: ['M4 7h16', 'M9 7V5h6v2', 'M6 7l1 13h10l1-13'],
  plus: ['M12 5v14', 'M5 12h14'],
  'chevron-down': ['M6 9l6 6 6-6'],
};

/** Создаёт иконку по имени: svg с обводками, недоступный для скринридера. */
export function createIcon(name: IconName): SVGElement {
  const svg = document.createElementNS(SVG_NS, 'svg');

  svg.setAttribute('viewBox', `0 0 ${ICON_SIZE} ${ICON_SIZE}`);
  svg.setAttribute('stroke-width', String(ICON_STROKE_WIDTH));
  svg.setAttribute('aria-hidden', 'true');
  svg.setAttribute('focusable', 'false');

  for (const path of ICON_PATHS[name]) {
    const element = document.createElementNS(SVG_NS, 'path');
    element.setAttribute('d', path);
    svg.append(element);
  }

  return svg;
}
